<div class="flex h-full min-h-0 flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-visual
        [form]="deliverableForm()"
        [creatorId]="executionAnalytics()?.creatorId"
        [isCustomMode]="true"
        [creators]="[]"
        [isViewMode]="true"
        [isExpanded]="true"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex flex-col gap-3">
      <h3 class="text-sm font-bold">
        {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
        {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
      </h3>

      <app-timeline-graph
        class="p-3 bg-shikenso-gray-base-24 rounded-2xl"
        [dotGraphData]="dotGraphData()"
        [chartConfiguration]="chartConfiguration()"
        [startTimestamp]="0"
        [endTimestamp]="totalMediaDurationSeconds()"
        (pointSelected)="onDataPointClick($event)"
      />
    </div>

    <div class="flex min-h-0 flex-1 flex-col gap-6 xl:flex-row xl:items-start">
      <div class="flex min-h-0 flex-1 flex-col">
        <ng-container [ngTemplateOutlet]="tableTemplate"></ng-container>
      </div>

      @if (currentMedia() && shouldRenderInPagePlayer()) {
        <div class="w-full xl:w-[360px] xl:shrink-0 pt-5">
          <app-post-media-viewer
            [media]="currentMedia()!"
            [videoConfiguration]="videoConfiguration()"
            [seekTime]="seekTime() ?? 0"
            [platformFeature]="executionAnalyticsWithFindings()?.platformFeature!"
          />
        </div>
      }
    </div>
  }
</div>

<ng-template #tableTemplate>
  <app-analytics-details-table
    matSort
    [dataSource]="dataSource"
    [dataCount]="dataCount()"
    [displayedColumns]="displayedColumns"
    [sort]="sort()"
    [selectedRowId]="selectedDataId()"
  >
    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'pages.campaignDetails.ctaAnalytics.details.visual.videoTime' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.timestamp }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'pages.campaignDetails.ctaAnalytics.details.visual.status' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="font-bold text-sm">
        <app-status-badge [status]="element.status" colorScheme="deliverable" size="small" />
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center justify-end gap-1">
          <button mat-icon-button class="mat-secondary-gray-border-button-color" (click)="onRowClick($event, element)">
            <app-icon
              [src]="
                executionAnalyticsWithFindings()?.platformFeature === EPlatformFeature.youtubeVod
                  ? '/icons/arrow-up-right.svg'
                  : '/icons/arrow-right.svg'
              "
              alt="View"
              [size]="12"
            />
          </button>
          @if (manualFindingStatusStore) {
            @if (hasRowPendingDeletions(element)) {
              @if (isVisualizerActing(element.id)) {
                <app-dots-spinner />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-gray-border-button-color"
                  (click)="onRevertRow(element); $event.stopPropagation()"
                >
                  <app-icon src="/icons/redo.svg" alt="Revert" [size]="16" />
                </button>
              }
            } @else if (canDelete()) {
              @if (isFindingInFlight(element.id)) {
                <app-dots-spinner />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-gray-border-button-color"
                  (click)="onDeleteSingleRowFinding(element); $event.stopPropagation()"
                >
                  <app-icon src="/icons/trash.svg" alt="Delete" [size]="16" />
                </button>
              }
            }
          }
        </div>
      </td>
    </ng-container>
  </app-analytics-details-table>
</ng-template>
